import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ScoreTrackerService } from '../../shared/services/score-tracker.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-match-congratulations',
  templateUrl: './match-congratulations.component.html',
  styleUrls: ['./match-congratulations.component.css']
})
export class MatchCongratulationsComponent implements OnInit, OnDestroy {

  showSpinner = false;

  userTokenInfo;

  socketConnectedStatus;

  connectionInfo = {
    adminID: '',
    playerID: '',
    eventID: 0,
    deviceCourtNumber: -1,
  };

  courtID;

  version = environment.version;  

  constructor(private authService: AuthService,
              private router: Router,
              private scoreTrackerService: ScoreTrackerService,
              private snackBar: MatSnackBar) 
              { 
                this.authService.hideNavBar();                
              }

  ngOnInit() 
  {
    this.userTokenInfo = this.authService.getUserTokenInfo();
    // ----------------------------------------------------------
    // Try to Connect to the server to make sure app is always connected
    // If its already connected then now new connection is created
    // ----------------------------------------------------------
    this.connectToServer();  

    this.getLocalDeviceCourtNumber();
   
  } 

  ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    this.authService.showNavBar();
  }


  goToAdminDeviceSetup()
  {

  }


  getLocalDeviceCourtNumber()
  {
    const deviceSetupInfo = this.scoreTrackerService.getLocalStorageDeviceInfo(); 
    this.courtID = deviceSetupInfo.deviceCourtNumber;
  }



  // ----------------------------------------------------------
  // If the Admin is going to use tablets - then they can use the 
  // redZoneActiveFlag / this will also be used Swap and Switch
  // to show the TV Mode view
  // ----------------------------------------------------------
  connectToServer() 
  {
    console.log('Auto Connecting To Server from Match Congratulations');

    let localUniqueDeviceInfo = this.checkDeviceSetup();
    this.connectionInfo.adminID = this.userTokenInfo.userID;
    this.connectionInfo.playerID = this.userTokenInfo.userID;
    this.connectionInfo.deviceCourtNumber = localUniqueDeviceInfo.deviceCourtNumber;

    this.scoreTrackerService.connectToServer(this.connectionInfo, null).subscribe(
    (data: any) => 
    {
      this.snackBar.open(data.message, null, { duration: 1000 });        
    },
    (error) => 
    {
      alert(error);
    });       


  }  

  // This is used if the device is refreshed while on the Match Congtratulations
  // it will need to connect as an admin device with adminID = NN, eventID = 0 and CourtID
  // from localstorage
  // Check to See if this device is setup as a courtside device
  //
  // ----------------------------------------------------
  // Check to See if the Device has been setup previously
  // Stored in local storage
  // ----------------------------------------------------
  checkDeviceSetup()
  {
    return this.scoreTrackerService.getLocalStorageDeviceInfo();   
  }  


  getLatestMatchInfo()
  {
    this.scoreTrackerService.getLatestMatchInfo().subscribe(
      (data: any) => 
      {
        this.router.navigate([`score-tracker/${ data.data.eventID }`],
        {
            queryParams: 
            {   
              leagueID:  data.data.eventID,
              matchID: data.data.matchID,
              gameID: data.data.gameID
            }                    
        });        
      },
      (error) => 
      {
        alert(error.message);
      });
  }


}
